import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import "./App.css";
import Sidenav from "./Components/Sidenav/Sidenav";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSilentRefresh } from "./hooks/useSilentRefresh";
import { useAuthRedirect } from "./hooks/useAuthRedirect";
import { useAuth, hasAuthParams } from "react-oidc-context";
import {
  LoginError,
  LoginMessage,
} from "./Components/LoginMessage/LoginMessage";
import uhclogo from "./assets/uhclogo.png";
import { GlobalStateContext, GlobalStateProvider } from "./GlobalStateProvider";

function App() {
  const auth = useAuth();

  useEffect(() => {
    document.title = `AI Chat`;
    if (uhclogo) {
      const linkElement = document.querySelector("link[rel='icon']");
      linkElement.href = uhclogo;
    }
  }, []);

  useEffect(() => {
    if (
      !hasAuthParams() &&
      !auth.isAuthenticated &&
      !auth.activeNavigator &&
      !auth.isLoading
    ) {
      auth.signinRedirect();
    }
  }, [
    auth.isAuthenticated,
    auth.activeNavigator,
    auth.isLoading,
    auth.signinRedirect,
    auth,
  ]);
  useAuthRedirect();
  useSilentRefresh();

  if (auth.activeNavigator) {
    return <LoginMessage />;
  }

  if (auth.error) {
    return <LoginError message={`Oops... ${auth.error.message}`} />;
  }

  // const login = async () => {
  //   const currentPath = window.location.pathname;
  //   console.log("currentPath", currentPath);
  //   // Create a Promise to set the original path in local storage
  //   const setOriginalPath = new Promise((resolve) => {
  //     localStorage.setItem("originalPath", currentPath);
  //     resolve();
  //   });
  //   // Wait for the original path to be written to local storage
  //   await setOriginalPath;
  //   auth.signinRedirect().catch((error) => {
  //     console.error("Error during signinRedirect:", error);
  //   });
  // };

  if (auth.isAuthenticated) {
    return (
      <GlobalStateProvider>
        <div className="App" style={{ display: "flex" }}>
          {/* <button onClick={login}>Login</button> */}
          <Sidenav />
          <div className="routes">
            <Outlet />
          </div>
        </div>
        <ToastContainer />
      </GlobalStateProvider>
    );
  }
  return <LoginMessage />;
}

export default App;
